import { CompanyTypeEnum } from 'shared/models/Client'
import {
  IUnitIdentificationFields,
  IUnitSectionIdFields,
} from 'shared/models/Unit'
import { IUnit } from '../models/Unit'

export const getPropertySectionNo = (
  unit: IUnit | null,
  companyTypeCode?: CompanyTypeEnum
) => {
  if (!unit) return ''

  switch (companyTypeCode) {
    case CompanyTypeEnum.BRL:
      return unit.propertySectionNo
    case CompanyTypeEnum.AS:
    case CompanyTypeEnum.BAS:
      return unit.propertySharedNo
    case CompanyTypeEnum.ESS:
    case CompanyTypeEnum.SA:
    case CompanyTypeEnum.TRS:
      return unit.sectionNo
    default:
      return unit.propertyNumber
  }
}

export const getPropertySectionNoFromIdFields = (
  idFields: IUnitIdentificationFields,
  companyTypeCode: string | undefined
): string => {
  switch (companyTypeCode) {
    case CompanyTypeEnum.BRL:
      return idFields.propertySectionNo
    case CompanyTypeEnum.AS:
    case CompanyTypeEnum.BAS:
      return idFields.propertySharedNo?.toString()
    case CompanyTypeEnum.ESS:
    case CompanyTypeEnum.SA:
    case CompanyTypeEnum.TRS:
      return idFields.sectionNo?.toString()
    default:
      return ''
  }
}

export const getUnitSectionNoFromIdFields = (
  idFields: IUnitSectionIdFields,
  companyTypeCode: string | undefined
): string => {
  switch (companyTypeCode) {
    case CompanyTypeEnum.BRL:
      return idFields.propertySectionNo || ''
    case CompanyTypeEnum.AS:
    case CompanyTypeEnum.BAS:
      return idFields.propertySharedNo || ''
    case CompanyTypeEnum.ESS:
    case CompanyTypeEnum.SA:
    case CompanyTypeEnum.TRS:
      return idFields.sectionNo?.toString() || ''
    default:
      return ''
  }
}

export const getCompanyTitleByCompanyCode = (
  companyCode: CompanyTypeEnum,
  title: string
) => {
  switch (companyCode) {
    case CompanyTypeEnum.FO:
    case CompanyTypeEnum.STI:
      return title
    default:
      if (title) {
        return `Vårt ${title.toLowerCase()}`
      }

      return `Vårt selskap`
  }
}
